document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initVariantes();
  initGaleria();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var delay = entry.target.dataset.mtDelay || (i * 60);
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.dataset.mtContador);
      var decimales = (el.dataset.mtContador.split('.')[1] || '').length;
      var duracion = 1200;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes = JSON.parse(dataEl.textContent);
    var inputId = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll('[data-mt-opcion]');
    var precioEl = document.querySelector('[data-mt-precio]');
    var precioCompareEl = document.querySelector('[data-mt-precio-compare]');
    var botonEl = form.querySelector('[data-mt-add-boton]');

    function actualizar() {
      var valores = Array.from(selects).map(function (s) { return s.value; });
      var match = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === valores[i]; });
      });
      if (!match) return;
      inputId.value = match.id;
      if (precioEl) precioEl.textContent = formatearDinero(match.price);
      if (precioCompareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioCompareEl.textContent = formatearDinero(match.compare_at_price);
          precioCompareEl.hidden = false;
        } else {
          precioCompareEl.hidden = true;
        }
      }
      if (botonEl) {
        if (match.available) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.dataset.textoDisponible;
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.dataset.textoAgotado;
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function formatearDinero(centavos) {
  return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
  });
}

function initGaleria() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        if (!principal) return;
        principal.src = mini.dataset.full;
        principal.srcset = '';
        minis.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      });
    });
  });
}
